import React from 'react';
import { useSelector } from 'react-redux';

import styles from './CustomDistributionMethod.module.scss';

import DestinationOption from '../../components/DestinationOption/DestinationOption';
import FundDisplayText from '../ProportionateDistributionMethod/FundDisplayText';
import {
  getRMDfunds,
  getBalanceAsOfDate,
} from '../../redux/modules/UserFunds/userFunds.selectors';
import { UNAVAILABLE_ONLINE } from '../../settings/settings';

const CustomDistributionMethodLockedFunds = () => {
  const {
    ROLLOVER_IRA: {
      lockedFunds: rolloverLockedFunds,
      unlockedFunds: rolloverUnlockedFunds,
    },
    TRADITIONAL_IRA: {
      lockedFunds: traditionalLockedFunds,
      unlockedFunds: traditionalUnlockedFunds,
    },
  } = useSelector(getRMDfunds);

  const balanceAsOfDate = useSelector(getBalanceAsOfDate);

  const rolloverLockedForCustom = [...rolloverLockedFunds];

  const traditionalLockedForCustom = [...traditionalLockedFunds];

  const allFunds = [
    ...rolloverLockedFunds,
    ...rolloverUnlockedFunds,
    ...traditionalUnlockedFunds,
    ...traditionalLockedFunds,
  ];
  return (
    <div className={` ${styles['locked-container']}`}>
      {rolloverLockedForCustom.length > 0 && (
        <>
          <div className={styles['locked-sub-title']}> {'Rollover IRA'}</div>
          {rolloverLockedForCustom.map((fund, index) => (
            <DestinationOption
              key={index}
              addressLock={true}
              disabled={true}
              isLockedFund={true}
              optionText={
                <FundDisplayText
                  retirement={true}
                  balanceAsOfDate={balanceAsOfDate}
                  fund={fund}
                  lock={true}
                  hasRmdEligibleFunds={allFunds.length > 1}
                  hasAllUnavailableOnline={
                    rolloverLockedForCustom.filter(
                      (el) => el?.lockNote === UNAVAILABLE_ONLINE
                    ).length === rolloverLockedForCustom.length &&
                    rolloverLockedForCustom.filter(
                      (el) => el?.lockNote === UNAVAILABLE_ONLINE
                    ).length > 0
                  }
                />
              }
              selectable={false}
              value={1}
              blockContainer={true}
              balanceAsOfDate={balanceAsOfDate}
            />
          ))}
        </>
      )}
      {traditionalLockedForCustom.length > 0 && (
        <>
          <div className={styles['locked-sub-title']}> {'Traditional IRA'}</div>

          {traditionalLockedForCustom.map((fund, index) => (
            <DestinationOption
              key={index}
              addressLock={true}
              blockContainer={true}
              disabled={true}
              isLockedFund={true}
              optionText={
                <FundDisplayText
                  balanceAsOfDate={balanceAsOfDate}
                  fund={fund}
                  lock={true}
                  hasRmdEligibleFunds={allFunds.length > 1}
                  hasAllUnavailableOnline={
                    traditionalLockedForCustom.filter(
                      (el) => el?.lockNote === UNAVAILABLE_ONLINE
                    ).length ===
                      traditionalLockedForCustom.length - 1 &&
                    traditionalLockedForCustom.filter(
                      (el) => el?.lockNote === UNAVAILABLE_ONLINE
                    ).length > 0
                  }
                />
              }
              selectable={false}
              value={1}
              balanceAsOfDate={balanceAsOfDate}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default CustomDistributionMethodLockedFunds;
